export const TAILORING_AUDIT_EVENT = "tailoring"
export const TAILORING_AUDIT_TYPE = "maintenanceRegime"
